import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const breadcrumbsStyles = makeStyles((theme: Theme) =>
    createStyles({
        breadcrumbText: {
            marginLeft: "10px",
            marginRight: "10px",
            textDecoration: "none",
            color: "rgba(0, 0, 0, 0.26)",
            fontSize: "15px",
            lineHeight: "18px",
            display: "flex",
        },
    })
);
